import React from 'react';
import { FDPaper } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import useMobileLayout from 'Hooks/useMobileLayout';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('ActionPaper', () => ({
  transparent: {
    '& > .FD-MuiPaper-root': {
      backgroundColor: 'transparent', // You can't just set the background color on the paper or else you can't use the appearance "outlined"
    },
  },
}));

export const ActionPaper = ({ children, completed, ...rest }) => {
  const classes = useStyles();
  const isMobile = useMobileLayout();
  return (
    <div className={completed ? classes.transparent : undefined}>
      <FDPaper
        appearance={completed ? 'outlined' : 'flat'}
        maxWidth={800}
        width={'100%'}
        padding={isMobile ? 3 : 6}
        {...rest}
      >
        {children}
      </FDPaper>
    </div>
  );
};

ActionPaper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};
